import { render, staticRenderFns } from "./QuestionCreate.vue?vue&type=template&id=0966d732&scoped=true&"
import script from "./QuestionCreate.vue?vue&type=script&lang=js&"
export * from "./QuestionCreate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCreate.vue?vue&type=style&index=0&id=0966d732&lang=scss&scoped=true&"
import style1 from "./QuestionCreate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0966d732",
  null
  
)

export default component.exports